import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="bg-white border-t border-gray-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
          <div className="text-sm text-gray-600">
            © {new Date().getFullYear()} North Lincolnshire and Humberside Sailing Club. All rights
            reserved.
          </div>
          <div className="flex items-center space-x-6">
            <Link
              to="/policies"
              className="text-sm text-gray-600 hover:text-primary-600 transition-colors font-medium"
            >
              Policies
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}





